<template>
  <div class="item-card">
    <div class="card-title">落地页</div>
    <div class="card-content">
      <ul class="modal-form">
        <el-form :model="formData" :rules="rules" ref="ldyFormRef">
          <li class="form-item">
            <span class="form-label">落地页类型：</span>
            <div class="form-value">
              <el-radio-group v-model="ldy_type">
                <el-radio :label="1">橙子建站</el-radio>
                <!-- <el-radio :label="2">程序化落地页</el-radio> -->
              </el-radio-group>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 6px">选择落地页：</span>
            <div class="form-value">
              <el-form-item prop="inputUrl" style="margin-bottom: 0px">
                <el-input style="width: 300px" v-model="formData.inputUrl" placeholder="请输入"></el-input>
                <span class="check-btn" @click="checkLdy">选择</span>
              </el-form-item>
            </div>
          </li>
        </el-form>
      </ul>
    </div>

    <!-- 落地页选择弹框 -->
    <select-ldy ref="ldySelectRef" @selectOk="selectOk"></select-ldy>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SelectLdy from "./sub/selectLdy.vue";
export default {
  components: {
    SelectLdy,
  },
  data() {
    return {
      ldy_type: 1,
      sitepage_id: null,
      formData: {
        inputUrl: "",
      },
      rules: {
        inputUrl: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (!value && this.checkedApp.os_type === "ANDROID") {
                //安卓下落地页必选
                callback(new Error("请输入或选择落地页"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    initOptions() {
      this.$nextTick(() => {
        this.renderdData();
      });
    },
    saveInStore() {
      this.$store.commit("set_sitePage_ttV2", {
        sitepage_url: this.formData.inputUrl || "",
      });
    },
    renderdData() {
      if (this.sitePage) {
        this.formData.inputUrl = this.sitePage.sitepage_url;
      }
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.ldyFormRef.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    //落地页相关
    checkLdy() {
      this.$refs.ldySelectRef.showModal();
    },
    selectOk(data) {
      this.formData.inputUrl = data;
    },
  },
  computed: {
    ...mapState({
      sitePage: (state) => state.PromotionTtV2.sitePage,
      checkedApp: (state) => state.PromotionTtV2.checkedApp,
    }),
  },
};
</script>

<style lang="less" scoped>
.item-card {
  background-color: #fff;
  padding: 24px;
  margin-bottom: 6px;
  .card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .card-content {
    margin-top: 20px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 20px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 95px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          // padding-top: 6px;
          &.require::before {
            content: "*";
            display: inline-block;
            color: red;
            margin-right: 4px;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(0, 0, 0, 0.65);
          }
          .list-wrap {
            .data-list {
              padding: 0px;
              margin: 0px;
              list-style: none;
              .add-btn {
                border-radius: 2px;
                border: 1px solid rgba(24, 144, 255, 1);
                box-sizing: border-box;
                background: rgba(255, 255, 255, 1);
                color: rgba(24, 144, 255, 1);
                margin: 0 14px 12px 0px;
              }
              .data-item {
                display: inline-block;
                border-radius: 2px;
                border: 1px solid rgba(0, 0, 0, 0.15);
                box-sizing: border-box;
                padding: 6px 8px;
                color: rgba(0, 0, 0, 0.85);
                font-size: 14px;
                margin: 0 14px 12px 0px;
                cursor: pointer;
                user-select: none;
                .dot-icon {
                  transform: rotate(90deg);
                  color: #666;
                }
              }
            }
            .list-footer {
              display: flex;
              justify-content: space-between;
              .list-length {
                color: rgba(0, 0, 0, 0.85);
                font-size: 14px;
              }
              .show-more {
                color: rgba(24, 144, 255, 1);
                font-size: 13px;
                cursor: pointer;
                margin-left: 20px;
                line-height: 24px;
                i {
                  margin-left: 4px;
                }
              }
            }
          }
          .edit-icon {
            cursor: pointer;
            margin-left: 5px;
          }
          .check-btn {
            color: #0b75ff;
            font-size: 12px;
            margin-left: 4px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
